import { useState } from 'react';
import {
  Button,
  Dropdown,
  Group,
  IconThreeDotsVer,
  Typography,
  useDropdownState,
  useModalState,
  Wrapper
} from '@screentone/core';

import { CommonEntityProps } from 'components/datamodel/commonEntityProps';
// eslint-disable-next-line import/no-cycle -- TODO: pre-existing cycle via DataModelContext, fix when context is restructured
import { useDataModelContext } from 'contexts/datamodel/useDataModel';
import { IssueSectionContainer } from 'data/generated/graphql';
import styles from './IssueSection.module.scss';
// eslint-disable-next-line import/no-cycle -- TODO: pre-existing cycle via DataModelContext, fix when context is restructured
import { NameChangeDialog } from './NameChangeDialog';
// eslint-disable-next-line import/no-cycle -- TODO: pre-existing cycle via DataModelContext, fix when context is restructured
import { IssuePage } from '../../Page/subtypes/IssuePage';

interface SectionProps extends CommonEntityProps {
  data: IssueSectionContainer;
}

export const IssueSection = ({ data: section, parentHierarchyId, index }: SectionProps) => {
  const [sectionLabel, setSectionLabel] = useState<string | undefined | null>(section.attributes.sectionLabel);

  const { generateHierarchyId } = useDataModelContext();

  const { open: isDropdownOpen, setOpen: setIsDropdownOpen, componentRef: dropdownRef } = useDropdownState();

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
  const { open, openModal, closeModal } = useModalState();

  const hierarchyId = generateHierarchyId(section, parentHierarchyId, index);

  return (
    <Wrapper data-model-hierarchy-id={hierarchyId} margin={{ bottom: 'md' }} data-testid="itp-page-section">
      <Wrapper className={styles.wrapper} margin={{ bottom: 'xs' }}>
        <Typography
          variant="header3"
          margin={{ bottom: 'none' }}
          className={styles.displayName}
          data-testid="itp-page-section-header"
        >
          {section.attributes.sectionLabel}
        </Typography>
        <Dropdown
          open={isDropdownOpen}
          onToggle={() => setIsDropdownOpen(!isDropdownOpen)}
          componentRef={dropdownRef}
          padding={{ all: 'none' }}
          position="right"
          trigger={<IconThreeDotsVer color="asphalt" />}
          margin={{ right: 'sm' }}
          data-testid="itp-page-ellipsis-dropdown"
        >
          <Group margin={{ all: 'md' }} gap="xs">
            {/* eslint-disable-next-line @typescript-eslint/no-unsafe-assignment */}
            <Button tertiary onClick={openModal} data-testid="itp-change-display-name">
              Change Display Name
            </Button>
          </Group>
        </Dropdown>
        {open && (
          <NameChangeDialog
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            closeModal={closeModal}
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            open={open}
            section={section}
            setSectionLabel={setSectionLabel}
            sectionLabel={sectionLabel}
          />
        )}
      </Wrapper>
      {section.collection.map((page, i) => (
        <IssuePage
          key={i}
          data={page}
          parentHierarchyId={hierarchyId}
          index={i}
          isFirst={i === 0}
          isLast={i === section.collection.length - 1}
          sectionIndex={index}
        />
      ))}
    </Wrapper>
  );
};
